export { default } from "./useGetVideoQuizSubmission";
